import React from 'react';
import styles from './HeaderLogo.module.scss';

const HeaderLogo = ({ logoImageSrc }) => {
  return (
    <a className={styles.logoContainer} href="/">
      {logoImageSrc && (
        <img className={styles.logoImage} src={logoImageSrc} alt="Isibute logo" />
      )}
      <span className={styles.logoText}>ISIBUTE</span>
    </a>
  );
};

export default HeaderLogo;
